import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Footer from '../components/Footer';
import Navbar from '../components/Navbar';

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export default function MyOrder() {
  const [orderData, setOrderData] = useState([]);

  const fetchMyOrder = async () => {
    try {
      const userEmail = localStorage.getItem('userEmail');
      console.log('User Email:', userEmail);

      const response = await fetch(`${BASE_URL}/api/auth/myOrderData`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          email: userEmail,
        }),
      });
      const data = await response.json();
      setOrderData(data.orderData.order_data.reverse());
    } catch (error) {
      console.error('Error:', error);
    }
  };

  useEffect(() => {
    fetchMyOrder();
  }, []);

  return (
    <div>
      <Navbar />
      <div  style={{marginTop:"80px"}}>
        <div className='row'>
          {orderData.length > 0 ? (
            <div className='container mb-5 d-flex flex-wrap'>
              {orderData.map((order, index) => {
                const orderDate = order[0]?.Order_date;
                const orderItems = order.slice(1);

                return (
                  <React.Fragment key={index}>
                    {orderDate && (
                      <div className='col-12 mt-5'>
                        <h4 className='text-center'>{orderDate}</h4>
                        <hr className='mx-auto w-25'/>
                      </div>
                    )}

                    {orderItems.map((item, itemIndex) => (
                      <div className='col-12 col-md-6 col-lg-3 container justify-content-center d-flex' key={itemIndex}>
                        <div className='card mt-3' style={{ width: '16rem', maxHeight: '400px' }}>
                          <img src={item.img} className='card-img-top' alt='...' style={{ height: '160px', objectFit: 'fill' }} />
                          <div className='card-body'>
                            <h5 className='card-title'>{item.name}</h5>
                            <div className='container w-100 p-0' style={{ height: '38px' }}>
                              <span className='m-1'>{item.qty}</span>
                              <span className='m-1'>{item.size}</span>
                              <div className='d-inline ms-2 h-100 w-20 fs-5'>₹{item.price}/-</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </React.Fragment>
                );
              })}
            </div>
          ) : (
            
            <div className='MyOrder mb-0'>
        <div style={{ textAlign: 'start', color: '#fff', marginLeft:'25%', marginTop:"8%"}}>
          <h1 style={{ fontSize: '3rem', marginBottom: '2rem' }}>Oops!!!</h1>
          <h3 style={{ fontSize: '2rem', marginBottom: '2rem' }}>No order data available.</h3>
          <Link
            className='text-white myorder-btn fw-bold'
            to='/'
            style={{
              fontSize: '1.5rem',
              textDecoration: 'none',
              padding: '0.5rem 1rem',
              backgroundColor: '#28a745',
              borderRadius: '5px',
            }}
          >
            Order now
          </Link>
        </div>
      </div>
          )}
        </div>
      </div>
      <Footer className="mb-0"/>
    </div>
  );
}
